import $ from "jquery";

let pendingStatusForm = null;

function paymentModal() {
  return document.querySelector("[data-payment-date-modal]");
}

function openPaymentModal(form) {
  const modal = paymentModal();
  if (!modal) return;

  pendingStatusForm = form;
  $(modal).modal("show");
  modal.querySelector("[data-payment-date-input]").focus();
}

document.addEventListener("submit", (event) => {
  const form = event.target.closest("[data-invoice-status-form]");
  if (!form || form.dataset.paymentDateConfirmed === "true") return;

  const select = form.querySelector("[data-invoice-status-select]");
  const paidAt = form.querySelector("[data-invoice-paid-at]");
  if (select && select.value === "betaald" && paidAt && !paidAt.value) {
    event.preventDefault();
    openPaymentModal(form);
  }
});

document.addEventListener("click", (event) => {
  const confirmButton = event.target.closest("[data-confirm-payment-date]");
  if (!confirmButton || !pendingStatusForm) return;

  const modal = paymentModal();
  const input = modal.querySelector("[data-payment-date-input]");
  if (!input.reportValidity()) return;

  pendingStatusForm.querySelector("[data-invoice-paid-at]").value = input.value;
  pendingStatusForm.dataset.paymentDateConfirmed = "true";
  $(modal).modal("hide");
  pendingStatusForm.requestSubmit();
  pendingStatusForm = null;
});

$(document).on("hidden.bs.modal", "[data-payment-date-modal]", () => {
  if (!pendingStatusForm) return;

  const select = pendingStatusForm.querySelector("[data-invoice-status-select]");
  if (select) select.value = select.dataset.currentStatus;
  pendingStatusForm = null;
});
